import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {BackgroundComponent} from '../../../shared/pages/background/background.component';
import { RouterLink  } from '@angular/router';

@Component({
  selector: 'app-register-page',
  imports: [RouterLink , FormsModule, BackgroundComponent],
  templateUrl: './register-page.component.html',
  styles: ``,
})
export class RegisterPageComponent {
  names       = signal<string | null>(null);
  lastNames   = signal<string | null>(null);
  dni         = signal<number|null>(null);
  phoneNumber = signal<number|null>(null);
  email       = signal<string|null>(null);
  password    = signal<string|null>(null);

  

  showValues(){
    console.log(this.names()+" "
    +this.lastNames()+" "
    +this.dni()+" "
    +this.phoneNumber()+" "
    +this.email()+" "
    +this.password()
   );
  }

  set namesModel(value: string) {
    this.names.set(value);
  }

  set lastNamesModel(value: string) {
    this.lastNames.set(value);
  } 

  set dniModel(value: number) {
    this.dni.set(value);
  }

  set phoneNumberModel(value: number) {
    this.phoneNumber.set(value);
  }

  set emailModel(value: string) {
    this.email.set(value);
  }

  set passwordModel(value: string) {
    this.password.set(value);
  }

}
